
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import ProspectClotureForm from '@/components/forms/ProspectClotureForm.vue'
import ClientForm from '@/components/forms/ClientForm.vue'
import VueScrollTo from 'vue-scrollto'
import {urlCall3cx} from '@/config/service'
import {optionsVslim} from '@/config/v-slim-dialog'

const prospectModule = namespace('prospect')

@Component({
  components: {
    BaseCardContainer,
    ClientForm,
    ProspectClotureForm
  }
})
export default class ProspectClient extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('createProspectClientAction') createProspectClient: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any

  get canCreateClient() {
    return !(
      !this.prospect.NOM ||
      this.prospect.PROPOSITIONS.length === 0 ||
      !this.prospect.ADRESSE ||
      !this.prospect.CODE_REF_TYPE_ENTITE ||
      !this.prospect.CODE_REF_PAYS ||
      (this.prospect.CODE_REF_PAYS === 'FRA' && !this.prospect.CODE_REF_DEPARTEMENT) ||
      !this.prospect.NOMBRE_LOTS_PRINCIPAUX ||
      !this.prospect.CONTACT_PRINCIPAL ||
      (this.prospect.CONTACT_PRINCIPAL && !this.prospect.CONTACT_PRINCIPAL.NOM) ||
      (this.prospect.CONTACT_PRINCIPAL && !this.prospect.CONTACT_PRINCIPAL.PRENOM) ||
      (this.prospect.CONTACT_PRINCIPAL && !this.prospect.CONTACT_PRINCIPAL.CODE_REF_CIVILITE) ||
      (this.prospect.CONTACT_PRINCIPAL && !this.prospect.CONTACT_PRINCIPAL.TELEPHONE1) ||
      (this.prospect.CONTACT_PRINCIPAL && !this.prospect.CONTACT_PRINCIPAL.EMAIL)
    )
  }

  get hasPropositions() {
    return !this.prospect.ID_CLIENT && this.prospect.PROPOSITIONS.length > 0
  }

  get hasDateCreation() {
    return this.prospect.DATE_CREATION_CLIENT !== null
  }

  getOffreOptions(item) {
    const p = []
    if (item.PROPOSITION_SECRETARIAT === 1) p.push('Secrétariat')
    if (item.PROPOSITION_EMPLOYES === 1) p.push('Employés')
    if (item.PROPOSITION_COACHING === 1) p.push('Coaching')
    if (item.PROPOSITION_AUDIT === 1) p.push('Audit')
    if (item.PROPOSITION_DEMARRAGE === 1) p.push('Démarrage')
    if (item.PROPOSITION_ASSISTANCE_INCLUSE === 1) p.push('Assistance incluse')
    return p.toString()
  }

  link3cx(tel) {
    return `${urlCall3cx}?phone=${tel}`
  }

  async onSubmit(data: any) {
    const {ok} = await this.$dialogs.confirm(
      'Vous êtes sur le point de créer le client dans Coprolib, êtes vous sur de vouloir continuer ?',
      optionsVslim
    )
    if (ok) {
      this.createProspectClient({
        id: this.$route.params.id,
        formParams: data
      }).then(async (data: any) => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }
}
